import React, { useEffect, useState } from 'react';
import { fetchLectureData } from '../services/googleSheets';
import { useConfig } from '../config/ConfigContext';

/**
 * Debug component to display data fetching information
 */
const DataDebugger = () => {
  const { config, loading: configLoading, error: configError } = useConfig();
  
  useEffect(() => {
    const loadData = async () => {
      if (configLoading || !config) {
        console.log('DataDebugger: Waiting for config...');
        return; 
      }
      if (configError) {
        console.error('DataDebugger: Config loading failed:', configError);
        return;
      }
      if (!config.google_sheet_id) {
        console.error('DataDebugger: google_sheet_id is missing from config.');
        return;
      }

      try {
        console.log(`DataDebugger: Fetching data for sheet ID: ${config.google_sheet_id}`);
        const result = await fetchLectureData(config.google_sheet_id);
        console.log('DataDebugger - Raw data:', result);
      } catch (error) {
        console.error('DataDebugger - Error fetching data:', error);
      }
    };
    
    loadData();
  }, [config, configLoading, configError]);

  return null; // Don't render anything
};

export default DataDebugger;
